import Vue, { FunctionDirective } from 'vue'
import { Component } from 'vue-property-decorator'
import {ModalHeader, ModalContent, ModalFooter,ContentItem} from '@gnb/components/Common'
import {LayoutView, ListCount} from '@gnb/components/Preference/Mail/Layout'
import PreferenceContentTemplate from '@gnb/templates/PreferenceContentTemplate.vue'
import { mapActions, mapGetters } from 'vuex'
import * as accountTypes from '@account/store/types'
import * as types from '@gnb/store/types'

@Component({
  components:{
      ModalHeader,
      ModalContent,
      ModalFooter,
      ContentItem,
      PreferenceContentTemplate,
      LayoutView,
      ListCount
    },
  computed: {
    ...mapGetters({
      user: accountTypes.USER,
      isLoading: types.COMMON_LOADDING
    })
  },
  methods:{
    ...mapActions({
      
    })
  } 
})

export default class Layout extends Vue {
  //
  // ──────────────────────────────────────────────── I ──────────
  //   :::::: D A T A : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────
  //

  get contentComponents() {
    return [ LayoutView ]
  }

  header: string = this.$t('레이아웃').toString();

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: A C T I O N S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  loading!: (option: boolean) => void;

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: G E T T E R S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  user!: account.User;
  isLoading !: boolean;
  
  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: M E T H O D S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  handleSave() {    
    const contens = this.$refs.contents as any[];
    let saveFunctions: Function[] = contens.map(c => c.save);  
    let savePromise: Promise<any>[] = saveFunctions.map(f => f());

    Promise.all(savePromise).then(res => {
      (window as any).alertAsync(this.$t('저장되었습니다'));
    })            
  } 
}